import { colors } from 'theme';

import { DividerHr } from './Divider.styled';

type Props = {
  dashed?: boolean;
  light?: boolean;
  marginTop: number;
  marginBottom: number;
  opaque?: boolean;
};

export function Divider({
  dashed,
  marginTop,
  marginBottom,
  light,
  opaque,
}: Props) {
  return (
    <DividerHr
      style={{
        borderBottomStyle: dashed ? 'dashed' : undefined,
        borderColor: light ? colors.selectionGrey : undefined,
        marginTop,
        marginBottom,
        opacity: opaque ? 0.2 : undefined,
      }}
    />
  );
}
